export function parseCoordinate(input: string): number | null {
  
  if (!input) return null;

  // If it’s just a number (DD.DDDD)
  const simple = parseFloat(input);
  if (!isNaN(simple)) return simple;

  // Check for DMS: 12°34'56.78" or 12 34 56.78
  const dmsMatch = input.match(
    /^(-?\d+)[°\s]+(\d+)[\'\s]+(\d+(?:\.\d+)?)[\"\s]*$/
  );
  if (dmsMatch) {
    const deg = Number(dmsMatch[1]);
    const min = Number(dmsMatch[2]);
    const sec = Number(dmsMatch[3]);
    if ([deg, min, sec].some(isNaN)) return null;
    return deg + min / 60 + sec / 3600;
  }

  // Check for DMM: 12°34.567 or 12 34.567
  const dmmMatch = input.match(/^(-?\d+)[°\s]+(\d+(?:\.\d+)?)/);
  if (dmmMatch) {
    const deg = Number(dmmMatch[1]);
    const min = Number(dmmMatch[2]);
    if ([deg, min].some(isNaN)) return null;
    return deg + min / 60;
  }

  return null; // unrecognized format
}
